!function (r, c) {
  "object" == typeof exports && "object" == typeof module ? module.exports = c(require("react")) : "function" == typeof define && define.amd ? define(["react"], c) : "object" == typeof exports ? exports["react-simple-flex-grid"] = c(require("react")) : r["react-simple-flex-grid"] = c(r.React);
}(this, function (r) {
  return function (r) {
    function c(t) {
      if (o[t]) return o[t].exports;
      var d = o[t] = {
        i: t,
        l: !1,
        exports: {}
      };
      return r[t].call(d.exports, d, d.exports, c), d.l = !0, d.exports;
    }
    var o = {};
    return c.m = r, c.c = o, c.i = function (r) {
      return r;
    }, c.d = function (r, o, t) {
      c.o(r, o) || Object.defineProperty(r, o, {
        configurable: !1,
        enumerable: !0,
        get: t
      });
    }, c.n = function (r) {
      var o = r && r.__esModule ? function () {
        return r.default;
      } : function () {
        return r;
      };
      return c.d(o, "a", o), o;
    }, c.o = function (r, c) {
      return Object.prototype.hasOwnProperty.call(r, c);
    }, c.p = "", c(c.s = 9);
  }([function (r, c, o) {
    "use strict";

    function t(r) {
      return r && r.__esModule ? r : {
        default: r
      };
    }
    Object.defineProperty(c, "__esModule", {
      value: !0
    }), c.Row = c.Col = void 0;
    var d = o(5),
      l = t(d),
      e = o(6),
      i = t(e);
    c.Col = l.default, c.Row = i.default;
  }, function (r, c, o) {
    var t, d;
    !function () {
      "use strict";

      function o() {
        for (var r = [], c = 0; c < arguments.length; c++) {
          var t = arguments[c];
          if (t) {
            var d = typeof t;
            if ("string" === d || "number" === d) r.push(t);else if (Array.isArray(t) && t.length) {
              var e = o.apply(null, t);
              e && r.push(e);
            } else if ("object" === d) for (var i in t) {
              l.call(t, i) && t[i] && r.push(i);
            }
          }
        }
        return r.join(" ");
      }
      var l = {}.hasOwnProperty;
      void 0 !== r && r.exports ? (o.default = o, r.exports = o) : (t = [], void 0 !== (d = function () {
        return o;
      }.apply(c, t)) && (r.exports = d));
    }();
  }, function (r, c) {
    r.exports = {
      "rct-grid-row": "rct-grid-row",
      "rct-grid-row-start": "rct-grid-row-start",
      "rct-grid-row-center": "rct-grid-row-center",
      "rct-grid-row-end": "rct-grid-row-end",
      "rct-grid-row-space-between": "rct-grid-row-space-between",
      "rct-grid-row-space-around": "rct-grid-row-space-around",
      "rct-grid-row-top": "rct-grid-row-top",
      "rct-grid-row-middle": "rct-grid-row-middle",
      "rct-grid-row-bottom": "rct-grid-row-bottom",
      "rct-grid-row-stretch": "rct-grid-row-stretch",
      "rct-grid-col-1": "rct-grid-col-1",
      "rct-grid-col-xs-1": "rct-grid-col-xs-1",
      "rct-grid-col-sm-1": "rct-grid-col-sm-1",
      "rct-grid-col-md-1": "rct-grid-col-md-1",
      "rct-grid-col-lg-1": "rct-grid-col-lg-1",
      "rct-grid-col-2": "rct-grid-col-2",
      "rct-grid-col-xs-2": "rct-grid-col-xs-2",
      "rct-grid-col-sm-2": "rct-grid-col-sm-2",
      "rct-grid-col-md-2": "rct-grid-col-md-2",
      "rct-grid-col-lg-2": "rct-grid-col-lg-2",
      "rct-grid-col-3": "rct-grid-col-3",
      "rct-grid-col-xs-3": "rct-grid-col-xs-3",
      "rct-grid-col-sm-3": "rct-grid-col-sm-3",
      "rct-grid-col-md-3": "rct-grid-col-md-3",
      "rct-grid-col-lg-3": "rct-grid-col-lg-3",
      "rct-grid-col-4": "rct-grid-col-4",
      "rct-grid-col-xs-4": "rct-grid-col-xs-4",
      "rct-grid-col-sm-4": "rct-grid-col-sm-4",
      "rct-grid-col-md-4": "rct-grid-col-md-4",
      "rct-grid-col-lg-4": "rct-grid-col-lg-4",
      "rct-grid-col-5": "rct-grid-col-5",
      "rct-grid-col-xs-5": "rct-grid-col-xs-5",
      "rct-grid-col-sm-5": "rct-grid-col-sm-5",
      "rct-grid-col-md-5": "rct-grid-col-md-5",
      "rct-grid-col-lg-5": "rct-grid-col-lg-5",
      "rct-grid-col-6": "rct-grid-col-6",
      "rct-grid-col-xs-6": "rct-grid-col-xs-6",
      "rct-grid-col-sm-6": "rct-grid-col-sm-6",
      "rct-grid-col-md-6": "rct-grid-col-md-6",
      "rct-grid-col-lg-6": "rct-grid-col-lg-6",
      "rct-grid-col-7": "rct-grid-col-7",
      "rct-grid-col-xs-7": "rct-grid-col-xs-7",
      "rct-grid-col-sm-7": "rct-grid-col-sm-7",
      "rct-grid-col-md-7": "rct-grid-col-md-7",
      "rct-grid-col-lg-7": "rct-grid-col-lg-7",
      "rct-grid-col-8": "rct-grid-col-8",
      "rct-grid-col-xs-8": "rct-grid-col-xs-8",
      "rct-grid-col-sm-8": "rct-grid-col-sm-8",
      "rct-grid-col-md-8": "rct-grid-col-md-8",
      "rct-grid-col-lg-8": "rct-grid-col-lg-8",
      "rct-grid-col-9": "rct-grid-col-9",
      "rct-grid-col-xs-9": "rct-grid-col-xs-9",
      "rct-grid-col-sm-9": "rct-grid-col-sm-9",
      "rct-grid-col-md-9": "rct-grid-col-md-9",
      "rct-grid-col-lg-9": "rct-grid-col-lg-9",
      "rct-grid-col-10": "rct-grid-col-10",
      "rct-grid-col-xs-10": "rct-grid-col-xs-10",
      "rct-grid-col-sm-10": "rct-grid-col-sm-10",
      "rct-grid-col-md-10": "rct-grid-col-md-10",
      "rct-grid-col-lg-10": "rct-grid-col-lg-10",
      "rct-grid-col-11": "rct-grid-col-11",
      "rct-grid-col-xs-11": "rct-grid-col-xs-11",
      "rct-grid-col-sm-11": "rct-grid-col-sm-11",
      "rct-grid-col-md-11": "rct-grid-col-md-11",
      "rct-grid-col-lg-11": "rct-grid-col-lg-11",
      "rct-grid-col-12": "rct-grid-col-12",
      "rct-grid-col-xs-12": "rct-grid-col-xs-12",
      "rct-grid-col-sm-12": "rct-grid-col-sm-12",
      "rct-grid-col-md-12": "rct-grid-col-md-12",
      "rct-grid-col-lg-12": "rct-grid-col-lg-12",
      "rct-grid-col-0": "rct-grid-col-0",
      "rct-grid-col-offset-0": "rct-grid-col-offset-0",
      "rct-grid-col-order-0": "rct-grid-col-order-0",
      "rct-grid-col-offset-1": "rct-grid-col-offset-1",
      "rct-grid-col-order-1": "rct-grid-col-order-1",
      "rct-grid-col-offset-2": "rct-grid-col-offset-2",
      "rct-grid-col-order-2": "rct-grid-col-order-2",
      "rct-grid-col-offset-3": "rct-grid-col-offset-3",
      "rct-grid-col-order-3": "rct-grid-col-order-3",
      "rct-grid-col-offset-4": "rct-grid-col-offset-4",
      "rct-grid-col-order-4": "rct-grid-col-order-4",
      "rct-grid-col-offset-5": "rct-grid-col-offset-5",
      "rct-grid-col-order-5": "rct-grid-col-order-5",
      "rct-grid-col-offset-6": "rct-grid-col-offset-6",
      "rct-grid-col-order-6": "rct-grid-col-order-6",
      "rct-grid-col-offset-7": "rct-grid-col-offset-7",
      "rct-grid-col-order-7": "rct-grid-col-order-7",
      "rct-grid-col-offset-8": "rct-grid-col-offset-8",
      "rct-grid-col-order-8": "rct-grid-col-order-8",
      "rct-grid-col-offset-9": "rct-grid-col-offset-9",
      "rct-grid-col-order-9": "rct-grid-col-order-9",
      "rct-grid-col-offset-10": "rct-grid-col-offset-10",
      "rct-grid-col-order-10": "rct-grid-col-order-10",
      "rct-grid-col-offset-11": "rct-grid-col-offset-11",
      "rct-grid-col-order-11": "rct-grid-col-order-11",
      "rct-grid-col-offset-12": "rct-grid-col-offset-12",
      "rct-grid-col-order-12": "rct-grid-col-order-12",
      "rct-grid-col-xs-0": "rct-grid-col-xs-0",
      "rct-grid-col-xs-offset-0": "rct-grid-col-xs-offset-0",
      "rct-grid-col-xs-order-0": "rct-grid-col-xs-order-0",
      "rct-grid-col-xs-offset-1": "rct-grid-col-xs-offset-1",
      "rct-grid-col-xs-order-1": "rct-grid-col-xs-order-1",
      "rct-grid-col-xs-offset-2": "rct-grid-col-xs-offset-2",
      "rct-grid-col-xs-order-2": "rct-grid-col-xs-order-2",
      "rct-grid-col-xs-offset-3": "rct-grid-col-xs-offset-3",
      "rct-grid-col-xs-order-3": "rct-grid-col-xs-order-3",
      "rct-grid-col-xs-offset-4": "rct-grid-col-xs-offset-4",
      "rct-grid-col-xs-order-4": "rct-grid-col-xs-order-4",
      "rct-grid-col-xs-offset-5": "rct-grid-col-xs-offset-5",
      "rct-grid-col-xs-order-5": "rct-grid-col-xs-order-5",
      "rct-grid-col-xs-offset-6": "rct-grid-col-xs-offset-6",
      "rct-grid-col-xs-order-6": "rct-grid-col-xs-order-6",
      "rct-grid-col-xs-offset-7": "rct-grid-col-xs-offset-7",
      "rct-grid-col-xs-order-7": "rct-grid-col-xs-order-7",
      "rct-grid-col-xs-offset-8": "rct-grid-col-xs-offset-8",
      "rct-grid-col-xs-order-8": "rct-grid-col-xs-order-8",
      "rct-grid-col-xs-offset-9": "rct-grid-col-xs-offset-9",
      "rct-grid-col-xs-order-9": "rct-grid-col-xs-order-9",
      "rct-grid-col-xs-offset-10": "rct-grid-col-xs-offset-10",
      "rct-grid-col-xs-order-10": "rct-grid-col-xs-order-10",
      "rct-grid-col-xs-offset-11": "rct-grid-col-xs-offset-11",
      "rct-grid-col-xs-order-11": "rct-grid-col-xs-order-11",
      "rct-grid-col-xs-offset-12": "rct-grid-col-xs-offset-12",
      "rct-grid-col-xs-order-12": "rct-grid-col-xs-order-12",
      "rct-grid-col-sm-0": "rct-grid-col-sm-0",
      "rct-grid-col-sm-offset-0": "rct-grid-col-sm-offset-0",
      "rct-grid-col-sm-order-0": "rct-grid-col-sm-order-0",
      "rct-grid-col-sm-offset-1": "rct-grid-col-sm-offset-1",
      "rct-grid-col-sm-order-1": "rct-grid-col-sm-order-1",
      "rct-grid-col-sm-offset-2": "rct-grid-col-sm-offset-2",
      "rct-grid-col-sm-order-2": "rct-grid-col-sm-order-2",
      "rct-grid-col-sm-offset-3": "rct-grid-col-sm-offset-3",
      "rct-grid-col-sm-order-3": "rct-grid-col-sm-order-3",
      "rct-grid-col-sm-offset-4": "rct-grid-col-sm-offset-4",
      "rct-grid-col-sm-order-4": "rct-grid-col-sm-order-4",
      "rct-grid-col-sm-offset-5": "rct-grid-col-sm-offset-5",
      "rct-grid-col-sm-order-5": "rct-grid-col-sm-order-5",
      "rct-grid-col-sm-offset-6": "rct-grid-col-sm-offset-6",
      "rct-grid-col-sm-order-6": "rct-grid-col-sm-order-6",
      "rct-grid-col-sm-offset-7": "rct-grid-col-sm-offset-7",
      "rct-grid-col-sm-order-7": "rct-grid-col-sm-order-7",
      "rct-grid-col-sm-offset-8": "rct-grid-col-sm-offset-8",
      "rct-grid-col-sm-order-8": "rct-grid-col-sm-order-8",
      "rct-grid-col-sm-offset-9": "rct-grid-col-sm-offset-9",
      "rct-grid-col-sm-order-9": "rct-grid-col-sm-order-9",
      "rct-grid-col-sm-offset-10": "rct-grid-col-sm-offset-10",
      "rct-grid-col-sm-order-10": "rct-grid-col-sm-order-10",
      "rct-grid-col-sm-offset-11": "rct-grid-col-sm-offset-11",
      "rct-grid-col-sm-order-11": "rct-grid-col-sm-order-11",
      "rct-grid-col-sm-offset-12": "rct-grid-col-sm-offset-12",
      "rct-grid-col-sm-order-12": "rct-grid-col-sm-order-12",
      "rct-grid-col-md-0": "rct-grid-col-md-0",
      "rct-grid-col-md-offset-0": "rct-grid-col-md-offset-0",
      "rct-grid-col-md-order-0": "rct-grid-col-md-order-0",
      "rct-grid-col-md-offset-1": "rct-grid-col-md-offset-1",
      "rct-grid-col-md-order-1": "rct-grid-col-md-order-1",
      "rct-grid-col-md-offset-2": "rct-grid-col-md-offset-2",
      "rct-grid-col-md-order-2": "rct-grid-col-md-order-2",
      "rct-grid-col-md-offset-3": "rct-grid-col-md-offset-3",
      "rct-grid-col-md-order-3": "rct-grid-col-md-order-3",
      "rct-grid-col-md-offset-4": "rct-grid-col-md-offset-4",
      "rct-grid-col-md-order-4": "rct-grid-col-md-order-4",
      "rct-grid-col-md-offset-5": "rct-grid-col-md-offset-5",
      "rct-grid-col-md-order-5": "rct-grid-col-md-order-5",
      "rct-grid-col-md-offset-6": "rct-grid-col-md-offset-6",
      "rct-grid-col-md-order-6": "rct-grid-col-md-order-6",
      "rct-grid-col-md-offset-7": "rct-grid-col-md-offset-7",
      "rct-grid-col-md-order-7": "rct-grid-col-md-order-7",
      "rct-grid-col-md-offset-8": "rct-grid-col-md-offset-8",
      "rct-grid-col-md-order-8": "rct-grid-col-md-order-8",
      "rct-grid-col-md-offset-9": "rct-grid-col-md-offset-9",
      "rct-grid-col-md-order-9": "rct-grid-col-md-order-9",
      "rct-grid-col-md-offset-10": "rct-grid-col-md-offset-10",
      "rct-grid-col-md-order-10": "rct-grid-col-md-order-10",
      "rct-grid-col-md-offset-11": "rct-grid-col-md-offset-11",
      "rct-grid-col-md-order-11": "rct-grid-col-md-order-11",
      "rct-grid-col-md-offset-12": "rct-grid-col-md-offset-12",
      "rct-grid-col-md-order-12": "rct-grid-col-md-order-12",
      "rct-grid-col-lg-0": "rct-grid-col-lg-0",
      "rct-grid-col-lg-offset-0": "rct-grid-col-lg-offset-0",
      "rct-grid-col-lg-order-0": "rct-grid-col-lg-order-0",
      "rct-grid-col-lg-offset-1": "rct-grid-col-lg-offset-1",
      "rct-grid-col-lg-order-1": "rct-grid-col-lg-order-1",
      "rct-grid-col-lg-offset-2": "rct-grid-col-lg-offset-2",
      "rct-grid-col-lg-order-2": "rct-grid-col-lg-order-2",
      "rct-grid-col-lg-offset-3": "rct-grid-col-lg-offset-3",
      "rct-grid-col-lg-order-3": "rct-grid-col-lg-order-3",
      "rct-grid-col-lg-offset-4": "rct-grid-col-lg-offset-4",
      "rct-grid-col-lg-order-4": "rct-grid-col-lg-order-4",
      "rct-grid-col-lg-offset-5": "rct-grid-col-lg-offset-5",
      "rct-grid-col-lg-order-5": "rct-grid-col-lg-order-5",
      "rct-grid-col-lg-offset-6": "rct-grid-col-lg-offset-6",
      "rct-grid-col-lg-order-6": "rct-grid-col-lg-order-6",
      "rct-grid-col-lg-offset-7": "rct-grid-col-lg-offset-7",
      "rct-grid-col-lg-order-7": "rct-grid-col-lg-order-7",
      "rct-grid-col-lg-offset-8": "rct-grid-col-lg-offset-8",
      "rct-grid-col-lg-order-8": "rct-grid-col-lg-order-8",
      "rct-grid-col-lg-offset-9": "rct-grid-col-lg-offset-9",
      "rct-grid-col-lg-order-9": "rct-grid-col-lg-order-9",
      "rct-grid-col-lg-offset-10": "rct-grid-col-lg-offset-10",
      "rct-grid-col-lg-order-10": "rct-grid-col-lg-order-10",
      "rct-grid-col-lg-offset-11": "rct-grid-col-lg-offset-11",
      "rct-grid-col-lg-order-11": "rct-grid-col-lg-order-11",
      "rct-grid-col-lg-offset-12": "rct-grid-col-lg-offset-12",
      "rct-grid-col-lg-order-12": "rct-grid-col-lg-order-12",
      "rct-grid-col-xl-1": "rct-grid-col-xl-1",
      "rct-grid-col-xl-2": "rct-grid-col-xl-2",
      "rct-grid-col-xl-3": "rct-grid-col-xl-3",
      "rct-grid-col-xl-4": "rct-grid-col-xl-4",
      "rct-grid-col-xl-5": "rct-grid-col-xl-5",
      "rct-grid-col-xl-6": "rct-grid-col-xl-6",
      "rct-grid-col-xl-7": "rct-grid-col-xl-7",
      "rct-grid-col-xl-8": "rct-grid-col-xl-8",
      "rct-grid-col-xl-9": "rct-grid-col-xl-9",
      "rct-grid-col-xl-10": "rct-grid-col-xl-10",
      "rct-grid-col-xl-11": "rct-grid-col-xl-11",
      "rct-grid-col-xl-12": "rct-grid-col-xl-12",
      "rct-grid-col-xl-0": "rct-grid-col-xl-0",
      "rct-grid-col-xl-offset-0": "rct-grid-col-xl-offset-0",
      "rct-grid-col-xl-order-0": "rct-grid-col-xl-order-0",
      "rct-grid-col-xl-offset-1": "rct-grid-col-xl-offset-1",
      "rct-grid-col-xl-order-1": "rct-grid-col-xl-order-1",
      "rct-grid-col-xl-offset-2": "rct-grid-col-xl-offset-2",
      "rct-grid-col-xl-order-2": "rct-grid-col-xl-order-2",
      "rct-grid-col-xl-offset-3": "rct-grid-col-xl-offset-3",
      "rct-grid-col-xl-order-3": "rct-grid-col-xl-order-3",
      "rct-grid-col-xl-offset-4": "rct-grid-col-xl-offset-4",
      "rct-grid-col-xl-order-4": "rct-grid-col-xl-order-4",
      "rct-grid-col-xl-offset-5": "rct-grid-col-xl-offset-5",
      "rct-grid-col-xl-order-5": "rct-grid-col-xl-order-5",
      "rct-grid-col-xl-offset-6": "rct-grid-col-xl-offset-6",
      "rct-grid-col-xl-order-6": "rct-grid-col-xl-order-6",
      "rct-grid-col-xl-offset-7": "rct-grid-col-xl-offset-7",
      "rct-grid-col-xl-order-7": "rct-grid-col-xl-order-7",
      "rct-grid-col-xl-offset-8": "rct-grid-col-xl-offset-8",
      "rct-grid-col-xl-order-8": "rct-grid-col-xl-order-8",
      "rct-grid-col-xl-offset-9": "rct-grid-col-xl-offset-9",
      "rct-grid-col-xl-order-9": "rct-grid-col-xl-order-9",
      "rct-grid-col-xl-offset-10": "rct-grid-col-xl-offset-10",
      "rct-grid-col-xl-order-10": "rct-grid-col-xl-order-10",
      "rct-grid-col-xl-offset-11": "rct-grid-col-xl-offset-11",
      "rct-grid-col-xl-order-11": "rct-grid-col-xl-order-11",
      "rct-grid-col-xl-offset-12": "rct-grid-col-xl-offset-12",
      "rct-grid-col-xl-order-12": "rct-grid-col-xl-order-12"
    };
  }, function (r, c, o) {
    r.exports = o(7)();
  }, function (c, o) {
    c.exports = r;
  }, function (r, c, o) {
    "use strict";

    function t(r) {
      return r && r.__esModule ? r : {
        default: r
      };
    }
    function d(r, c, o) {
      return c in r ? Object.defineProperty(r, c, {
        value: o,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : r[c] = o, r;
    }
    function l(r, c) {
      var o = {};
      for (var t in r) {
        c.indexOf(t) >= 0 || Object.prototype.hasOwnProperty.call(r, t) && (o[t] = r[t]);
      }
      return o;
    }
    function e(r) {
      var c,
        o = r.span,
        t = r.offset,
        e = r.className,
        f = r.children,
        n = r.prefix,
        m = void 0 === n ? "rct-grid-col" : n,
        a = r.order,
        x = l(r, ["span", "offset", "className", "children", "prefix", "order"]),
        y = {};
      ["xs", "sm", "md", "lg", "xl"].forEach(function (r) {
        if (x[r]) {
          var c,
            o = {};
          "number" == typeof x[r] ? o.span = x[r] : "object" === g(x[r]) && (o = x[r] || {}), delete x[r], y = Object.assign({}, y, (c = {}, d(c, p.default[m + "-" + r + "-" + o.span], void 0 !== o.span), d(c, p.default[m + "-" + r + "-offset-" + o.offset], o.offset || 0 === o.offset), d(c, p.default[m + "-" + r + "-order-" + o.order], o.order || 0 === o.order), c));
        }
      });
      var b = (0, u.default)((c = {}, d(c, p.default[m + "-" + o], void 0 !== o), d(c, p.default[m + "-offset-" + t], t), d(c, p.default[m + "-order-" + a], a), c), e, y);
      return s.default.createElement("div", i({}, x, {
        className: b
      }), f);
    }
    Object.defineProperty(c, "__esModule", {
      value: !0
    });
    var i = Object.assign || function (r) {
        for (var c = 1; c < arguments.length; c++) {
          var o = arguments[c];
          for (var t in o) {
            Object.prototype.hasOwnProperty.call(o, t) && (r[t] = o[t]);
          }
        }
        return r;
      },
      g = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (r) {
        return typeof r;
      } : function (r) {
        return r && "function" == typeof Symbol && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
      },
      f = o(4),
      s = t(f),
      n = o(3),
      m = t(n),
      a = o(1),
      u = t(a),
      x = o(2),
      p = t(x);
    m.default.oneOfType([m.default.string, m.default.number]), m.default.oneOfType([m.default.number, m.default.object]);
    e.defaultProps = {
      offset: 0
    }, c.default = e;
  }, function (r, c, o) {
    "use strict";

    function t(r) {
      return r && r.__esModule ? r : {
        default: r
      };
    }
    function d(r, c, o) {
      return c in r ? Object.defineProperty(r, c, {
        value: o,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : r[c] = o, r;
    }
    function l(r, c) {
      var o = {};
      for (var t in r) {
        c.indexOf(t) >= 0 || Object.prototype.hasOwnProperty.call(r, t) && (o[t] = r[t]);
      }
      return o;
    }
    function e(r, c) {
      if (!(r instanceof c)) throw new TypeError("Cannot call a class as a function");
    }
    function i(r, c) {
      if (!r) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return !c || "object" != typeof c && "function" != typeof c ? r : c;
    }
    function g(r, c) {
      if ("function" != typeof c && null !== c) throw new TypeError("Super expression must either be null or a function, not " + typeof c);
      r.prototype = Object.create(c && c.prototype, {
        constructor: {
          value: r,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), c && (Object.setPrototypeOf ? Object.setPrototypeOf(r, c) : r.__proto__ = c);
    }
    Object.defineProperty(c, "__esModule", {
      value: !0
    });
    var f = Object.assign || function (r) {
        for (var c = 1; c < arguments.length; c++) {
          var o = arguments[c];
          for (var t in o) {
            Object.prototype.hasOwnProperty.call(o, t) && (r[t] = o[t]);
          }
        }
        return r;
      },
      s = function () {
        function r(r, c) {
          for (var o = 0; o < c.length; o++) {
            var t = c[o];
            t.enumerable = t.enumerable || !1, t.configurable = !0, "value" in t && (t.writable = !0), Object.defineProperty(r, t.key, t);
          }
        }
        return function (c, o, t) {
          return o && r(c.prototype, o), t && r(c, t), c;
        };
      }(),
      n = o(4),
      m = t(n),
      a = o(3),
      u = (t(a), o(1)),
      x = t(u),
      p = o(2),
      y = t(p),
      b = function (r) {
        function c() {
          return e(this, c), i(this, (c.__proto__ || Object.getPrototypeOf(c)).apply(this, arguments));
        }
        return g(c, r), s(c, [{
          key: "render",
          value: function value() {
            var r,
              c = this.props,
              o = c.justify,
              t = c.align,
              e = c.className,
              i = c.gutter,
              g = c.style,
              s = c.children,
              n = c.prefix,
              a = void 0 === n ? "rct-grid-row" : n,
              u = l(c, ["justify", "align", "className", "gutter", "style", "children", "prefix"]),
              p = (0, x.default)(y.default["" + a], (r = {}, d(r, y.default[a + "-" + o], o), d(r, y.default[a + "-" + t], t), r), e),
              b = i > 0 ? Object.assign({}, {
                marginLeft: i / -2,
                marginRight: i / -2
              }, g) : g,
              v = m.default.Children.map(s, function (r) {
                return r ? r.props && i > 0 ? m.default.cloneElement(r, {
                  style: Object.assign({}, {
                    paddingLeft: i / 2,
                    paddingRight: i / 2
                  }, r.props.style)
                }) : r : null;
              });
            return m.default.createElement("div", f({}, u, {
              className: p,
              style: b
            }), v);
          }
        }]), c;
      }(m.default.Component);
    b.defaultProps = {
      gutter: 0,
      justify: "start",
      align: "top"
    }, c.default = b;
  }, function (r, c, o) {
    "use strict";

    function t() {}
    function d() {}
    var l = o(8);
    d.resetWarningCache = t, r.exports = function () {
      function r(r, c, o, t, d, e) {
        if (e !== l) {
          var i = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
          throw i.name = "Invariant Violation", i;
        }
      }
      function c() {
        return r;
      }
      r.isRequired = r;
      var o = {
        array: r,
        bool: r,
        func: r,
        number: r,
        object: r,
        string: r,
        symbol: r,
        any: r,
        arrayOf: c,
        element: r,
        elementType: r,
        instanceOf: c,
        node: r,
        objectOf: c,
        oneOf: c,
        oneOfType: c,
        shape: c,
        exact: c,
        checkPropTypes: d,
        resetWarningCache: t
      };
      return o.PropTypes = o, o;
    };
  }, function (r, c, o) {
    "use strict";

    r.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  }, function (r, c, o) {
    o(0), r.exports = o(0);
  }]);
});